import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class PageSetupAreaManagementApi implements IAPI {
  prefix = '/PageSetupAreaManagement'

  fetchList () {
    return API.get<TPageSetupManagement.TState['pageSetupAreaList']>(`${this.prefix}/GetList`)
  }

  fetchSingle (id: string) {
    return API.get<TPageSetupManagement.TState['pageSetupAreaUpsert']>(`${this.prefix}/GetById?id=${id}`)
  }

  async create (data: any) {
    const response = await API.post<TPageSetupManagement.TState['pageSetupAreaUpsert']>(`${this.prefix}/Create`, data)
    return response.data
  }

  async update (data: any) {
    const response = await API.put<TPageSetupManagement.TState['pageSetupAreaUpsert']>(`${this.prefix}/Update`, data)
    return response.data
  }

  async delete (id: string) {
    const response = await API.delete(`${this.prefix}/Delete?id=${id}`)
    return response.data
  }

  fetchSortedAndFilterOptions (code: string) {
    return API.get<TPageSetupManagement.TState['displayScreenOptionList']['data']>(`${this.prefix}/GetSortedAndFilterOptions?code=${code}`)
  }
}

export const pageSetupAreaManagementApi = new PageSetupAreaManagementApi()
